import React, { useState, useEffect, useRef } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DropdownLogin from "../Dropdown/DropdownLogin";
import { useData } from "../../services/DataContext";

const HeaderUser = () => {
  const [dropdown, setDropdown] = useState(false);
  const { userInfo } = useData();
  const dropdownRef = useRef(null);

  const handleClickDropdown = () => {
    setDropdown((prevDropdown) => !prevDropdown);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="flex absolute w-full left-0 bottom-0" ref={dropdownRef}>
        <div className="md:p-2 select-none w-full">
          <div className="flex flex-col float-right bg-white p-2 md:p-0 rounded-lg w-full" onClick={handleClickDropdown}>
            <div className="flex flex-row">
              <div className="flex flex-col pr-2 justify-center cursor-pointer mx-auto">
                <p className="uppercase text-xs text-zinc-400">{userInfo.email} </p>
                <p className="text-lg text-primary font-bold">{userInfo.fullName}</p>
              </div>
              <div className="flex mr-3">
                {dropdown ? (
                  <ArrowBackIosIcon className="my-auto cursor-pointer text-dark-primary"/>
                ) : (
                  <ArrowForwardIosIcon className="my-auto cursor-pointer text-dark-primary"/>
                )}
                {dropdown && <DropdownLogin open={dropdown}/>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderUser;
